import { observer } from 'mobx-react';
import React, { useState, useEffect } from 'react';
import { BaseSyntheticEvent } from 'react';
import { CQAppConstant } from '../../../../app-constants';
import { CQCheckbox } from '../../../../common/cq-inputs';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps {
    templateName: string;
    fieldData: IFieldData
}

const CQBoolean = (props: IProps) => {
    const { templateName, fieldData: { inputParamKey } } = props;
    const outputConfigObject = CQMasterDataStore.OutputConfig.getStoreData(templateName);
    const [state, setState] = useState<boolean>(outputConfigObject[inputParamKey]);

    useEffect(() => {
        CQMasterDataStore
            .OutputConfig
            .updateTemplatePropertyValue(templateName, inputParamKey, state);
    }, [state, inputParamKey, templateName]);

    const handleChangeCheckbox = (e: BaseSyntheticEvent , value: boolean) => {
        setState(value);
    };

    return(
        <CQCheckbox
            key= {inputParamKey} 
            label= ''
            onToggleChanged= {handleChangeCheckbox}
            value= {outputConfigObject[inputParamKey]}
            config={{
                isDisabled: 
                    templateName === "cqEsig100" && 
                    inputParamKey === "esig" && 
                    [CQAppConstant.COMPONENT_TYPE_FLOW, CQAppConstant.COMPONENT_TYPE_ESIG_ONLY].includes(outputConfigObject["componentType"]),
                variant: 'toggle'
            }}
        />
    );
}

export default observer(CQBoolean);